import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.4668 2.93372L10.1335 16.8004" stroke="#262626" stroke-width="2" stroke-linecap="round" />
    <path
      d="M7.4668 2.996C8.77183 2.35839 14.4001 6.18427 18.5595 6.18404C21.1696 6.18408 15.3536 12.313 10.1335 10.4001C9.57541 10.1661 9.23266 9.90289 8.77183 9.63882"
      stroke="#262626"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M12.8 15C16.8427 15.1509 20 16.4331 20 17.9926C20 19.6535 16.4183 21 12 21C7.58172 21 4 19.6535 4 17.9926C4 17.0779 5.08614 16.2586 6.8 15.7071"
      stroke="#262626"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

const activedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.2801 1.95121C7.44117 1.92057 7.60055 1.93041 7.74777 1.9736C8.06002 1.92793 8.36188 1.9669 8.59178 2.01106C8.94635 2.07917 9.33539 2.20372 9.72736 2.34806C10.2991 2.55861 10.9748 2.84913 11.6828 3.15355C11.9369 3.26281 12.1951 3.37387 12.4543 3.48366C14.5031 4.35172 16.7128 5.18383 18.5599 5.18373C19.0292 5.18374 19.7258 5.32491 20.0588 6.00212C20.3497 6.59388 20.1454 7.1977 19.9812 7.54197C19.6186 8.30212 18.8223 9.12712 17.8709 9.81819C16.0251 11.1589 13.0571 12.3723 10.1042 11.4456L10.9826 16.0631C11.0858 16.6057 10.7296 17.1292 10.1871 17.2324C9.64451 17.3356 9.12101 16.9794 9.0178 16.4369L6.4846 3.12047C6.43283 2.84835 6.49663 2.58101 6.64154 2.3691L6.64111 2.36632L6.64434 2.36503C6.78844 2.15651 7.01142 2.00232 7.2801 1.95121ZM18.2076 6.60527C18.2096 6.59298 18.2124 6.58604 18.2124 6.58604C18.2124 6.58604 18.2121 6.59192 18.2076 6.60527ZM7.14204 14.6322C7.41851 14.5532 7.69823 14.7346 7.75052 15.0174L8.07197 16.7554C8.28057 17.8401 9.32899 18.5503 10.4137 18.3417C11.4984 18.1331 12.2086 17.0847 12 16L11.6991 14.3646C11.6643 14.1754 11.8076 14 12 14C16.9706 14 21 15.7909 21 18C21 20.2091 16.9706 22 12 22C7.02944 22 3 20.2091 3 18C3 16.5861 4.65057 15.3435 7.14204 14.6322Z"
      fill="url(#paint0_linear_18903_5710)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_18903_5710"
        x1="5.84211"
        y1="3.51508"
        x2="22.148"
        y2="18.6377"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5891FF" />
        <stop offset="1" stop-color="#3768FA" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconActive() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
